<template>
  <el-dialog
    :title="title"
    v-model="isVisible"
    width="1000px"
    :before-close="handleClose"
    v-bind="$attrs"
    :show-close="false"
    :close-on-click-modal="false"
    :element-loading-text="lodingText"
  >
    <div v-loading="loading" :element-loading-text="lodingText">
      <div class="dialog-content">
        <div
          v-for="(item, index) in list"
          @click="currentId = index"
          :style="{ border: currentId === index ? '1px solid #4fa1c4' : '' }"
          :key="index"
          class="mulu-item"
        >
          <div class="right">
            <h5>{{ item.label.title }}</h5>
            <el-tree
              style="max-width: 600px"
              :data="item.data"
              node-key="id"
              default-expand-all
              :expand-on-click-node="false"
              @node-contextmenu="handleContextMenu"
              @node-click="handleNodeClick"
            >
              <template #default="{ node, data }">
                <div
                  class="custom-tree-node tree-node"
                  :data-id="node.id"
                  @dblclick="editNode(node, data)"
                >
                  <span v-if="!editStatus[node.id]">{{ node.label }}</span>
                  <el-input
                    style="width: 65%"
                    v-else
                    size="mini"
                    v-model="editValue[node.id]"
                    @blur="saveEdit(node, data, index)"
                    ref="editInput"
                    maxlength="20"
                    :class="{ 'content-error': !node.label }"
                  ></el-input>
                  <span v-if="!node.label.trim()" class="error"
                    >标题不可为空</span
                  >
                  <div>
                    <el-button
                      type="text"
                      v-if="node.level < 3"
                      @click="append(data)"
                    >
                      添加
                    </el-button>
                    <el-button
                      style="margin-left: 4px"
                      type="text"
                      @click="remove(node, data)"
                      v-if="item.data.length > 1 || node.level != 1"
                    >
                      删除
                    </el-button>
                  </div>
                </div>
              </template>
            </el-tree>
          </div>
        </div>
      </div>
      <span style="display: flex; justify-content: end">
        <el-button @click="handleClose" size="small">取消</el-button>
        <el-button type="primary" @click="handleConfirm" size="small"
          >确定</el-button
        >
      </span>
    </div>
  </el-dialog>
</template>

<script setup>
import { ref, watch, reactive, nextTick } from "vue"
import { ElDialog, ElButton } from "element-plus"
import { ElMessage } from "element-plus"
import { outline, report } from "./imgApi.js"
const dataSource = ref([
  {
    id: 1,
    label: "Level one 1",
    children: [
      {
        id: 4,
        label: "Level two 1-1",
        children: [
          {
            id: 9,
            label: "Level three 1-1-1",
          },
          {
            id: 10,
            label: "Level three 1-1-2",
          },
        ],
      },
    ],
  },
  {
    id: 2,
    label: "Level one 2",
    children: [
      {
        id: 5,
        label: "Level two 2-1",
      },
      {
        id: 6,
        label: "Level two 2-2",
      },
    ],
  },
  {
    id: 3,
    label: "Level one 3",
    children: [
      {
        id: 7,
        label: "Level two 3-1",
      },
      {
        id: 8,
        label: "Level two 3-2",
      },
    ],
  },
])
const loading = ref(false)
const lodingText = ref("目录生成中...")
// Props
const props = defineProps({
  title: {
    type: String,
    default: "提示",
  },
  width: {
    type: String,
    default: "1000px",
  },
  visible: {
    type: Boolean,
    default: false,
  },
  profession: {
    type: String,
    default: "",
  },
  reportValue: {
    type: String,
    default: '',
  },
  companyName: {
    type: String,
    default: '',
  },
  codeList: {
    type: Array,
    default: () => {
      return []
    },
  }
})
// let dataBaic={
//     // "basic": /
//     "detailed":
// }
const currentId = ref(0)
const list = reactive([
  {
    // data: [
    //   {
    //     id: 2,
    //     label: "市场规模",
    //   },
    //   {
    //     id: 3,
    //     label: "竞争格局",
    //   },
    //   {
    //     id: 4,
    //     label: "发展趋势",
    //   },
    //   {
    //     id: 5,
    //     label: "投资建议",
    //   },
    // ],
    value:
      "人工智能人工智能人工智能人工智能人工智能人工智能人工智能人工智能人工智能人工智能人工智能人工智能人工智能人工智能人工智能人工智能人工智能人工智能人工智能",
    label: {
      title: "目录一",
      list: [{ label: "目录1" }, { label: "目录2" }],
    },
  },
  {
    data: [],
    value:
      "人工智能人工智能人工智能人工智能人工智能人工智能人工智能人工智能人工智能人工智能人工智能人工智能人工智能人工智能人工智能人工智能人工智能人工智能人工智能",
    label: {
      title: "目录二",
      list: [{ label: "目录1" }, { label: "目录2" }],
    },
  },
])
const editStatus = reactive({})
const editValue = reactive({})
// const isEditing = ref(false);
const handleNodeClick = (data, node) => {
  console.log("Node clicked:", node.label)
}

const handleContextMenu = (event, data, node) => {
  event.preventDefault()
  console.log("Context menu clicked:", node.label)
}
const editNode = (node, data) => {
  editStatus[node.id] = true
  editValue[node.id] = node.label
  nextTick(() => {
    const input = document.querySelector(
      `.tree-node[data-id="${node.id}"] .el-input__inner`
    )
    input.focus()
  })
}

const isNull = ref(false)
const saveEdit = (node, data, index) => {
  console.log(data, node, "data", editValue[node.id])
  data.label = editValue[node.id]

  console.log("9999")
  if (!editValue[node.id]) {
    nextTick(() => {
      const input = document.querySelector(
        `.tree-node[data-id="${node.id}"] .el-input__inner`
      )
      input.focus()
    })
  } else {
    editStatus[node.id] = false
  }
}

const handleEditBlur = (node, data) => {
  // 失去焦点时保存编辑状态，并退出编辑模式
  // this.$set(data, 'isEditing', false);
  // 这里可以添加保存数据的逻辑，例如发送到服务器等
}
const catalogueData = reactive({
  abstract: "",
})
const reconnect = () => {
  WebSocketCatalogue(request.data)
}
const manuallyDisconnect = ref(true)
const WebSocketCatalogue = (request) => {
  lodingText.value = "数据生成中..."
  if ("WebSocket" in window) {
    manuallyDisconnect.value = true
    catalogueData.abstract = new WebSocket(
      "ws://172.16.210.61:82/tradelab/api/ws/report"
    )
    loading.value = true
    catalogueData.abstract.onmessage = (res) => {
      if (res.data != "[[DONE]]") {
        loading.value = false
        manuallyDisconnect.value = false
        catalogueData.abstract.close()
        let data = res.data.replace(/```html/g, " ").replace(/```/g, " ")
        emit("confirm", data)
      }
    }

    catalogueData.abstract.onopen = (res) => {
      console.log("Websocket ___ opened.", res)
      setTimeout(() => {
        catalogueData.abstract.send(JSON.stringify(request))
      }, 1000)
    }
    catalogueData.abstract.onerror = (error) => {
      console.log("Websocket ___ occurred.", error)
    }
    catalogueData.abstract.onclose = () => {
      console.log("Websocket __ closed.")
      if (manuallyDisconnect.value) {
        reconnect()
      }
    }
    //......此处省略ws其他属性操作
  } else {
    alert("当前浏览器 Not support websocket")
  }
}
const getOutline = () => {
  loading.value = true
  let industry = props.profession
    ? JSON.parse(props.profession).industryName
    : ""
  list[0].data = []
  list[1].data = []
  let data={industry: industry};
  if(props.reportValue==6||props.reportValue==='公司研究'){
    data["template_type"]="company";
    console.log(props.companyName,)
    data["industry"]=props.companyName||(props.codeList[0].sharesName.split('_')[1]).trim();
   
  }else{
    data["template_type"]="industry"
  }
  
  outline(data).then((res) => {
    console.log(res, "金融业")
    if (res.status == 200) {
      list[0].data = res.data.outline.basic//.map((item)=>{item.label=item.title;return item})

      list[1].data = res.data.outline.detailed//.map((item)=>{item.label=item.title;return item})
      loading.value = false
      console.log(  list,'99999')
    }
  })
}
// outline({industry:'金融业'}).then((res)=>{
//   console.log(res,'金融业')
// })

// report().then((res=>{
//   console.log(res,'report-金融业')
// }))
// Emits
const emit = defineEmits(["update:visible", "close", "confirm"])
let id = 100
// Data 模板

const isVisible = ref(props.visible)
const append = (data) => {
  console.log(data, "data")
  const newChild = { id: id++, label: "标题名称", children: [] }
  if (!data.children) {
    data.children = []
  }
  data.children.push(newChild)
  dataSource.value = [...dataSource.value]
}

const remove = (node, data) => {
  const parent = node.parent
  const children = parent.data.children || parent.data
  const index = children.findIndex((d) => d.id === data.id)
  
  children.splice(index, 1)
  dataSource.value = [...dataSource.value]
}
// Watchers
watch(
  () => props.visible,
  (newVal) => {
    isVisible.value = newVal
  }
)
watch(isVisible, (newVal) => {
  emit("update:visible", newVal)
  if (newVal) {
    currentId.value = 0
    lodingText.value = "目录生成中..."
    // list[0].data = [
    //   {
    //     id: 1,
    //     label: "行业概况",
    //     content:
    //       "介绍农、林、牧、渔业的基本定义和涵盖范围；分析行业的历史发展背景、政策环境（如农业补贴、环保法规等）以及在全球经济中的地位；概述行业的主要特点和发展阶段。",
    //   },
    //   {
    //     id: 2,
    //     label: "市场规模",
    //     content:
    //       "提供全球及中国农、林、牧、渔业的市场规模数据（包括产值、产量、进出口额等），并结合历史数据进行趋势分析；细分各子行业（如种植业、畜牧业、林业、渔业）的市场占比及增长潜力；引用权威机构（如FAO、国家统计局）的数据支持分析。",
    //   },
    //   {
    //     id: 3,
    //     label: "竞争格局",
    //     content:
    //       "分析行业内主要参与者的分布情况（企业数量、区域分布等），并列举国内外龙头企业及其市场份额；探讨市场竞争的主要驱动因素（如技术进步、成本控制、品牌效应等）；评估行业集中度，并预测未来竞争格局的变化趋势。",
    //   },
    //   {
    //     id: 4,
    //     label: "发展趋势",
    //     content:
    //       "分析农、林、牧、渔业在技术创新（如精准农业、基因改良、智能养殖设备）、可持续发展（如碳中和目标、生态农业）、政策导向（如乡村振兴战略、绿色农业政策）等方面的发展趋势；讨论消费者需求变化对行业的影响（如有机食品、健康饮食趋势）；预测未来5-10年的行业发展方向。",
    //   },
    //   {
    //     id: 5,
    //     label: "投资建议",
    //     content:
    //       "基于行业现状和发展趋势，提出针对投资者的具体建议，包括优先关注的子行业（如高附加值农产品、特色林产品、现代化养殖设施等）；分析投资风险（如自然灾害、价格波动、政策调整等）并提供规避措施；推荐适合不同投资主体（如政府、企业、个人）的投资策略。",
    //   },
    // ]
    // list[1].data = [
    //   {
    //     id: 2,
    //     label: "产业链分析",
    //     content:
    //       "全面梳理金融业的上下游产业链结构，包括金融机构、技术支持方（如金融科技公司）、监管机构以及终端用户等关键环节，并分析各环节间的互动关系及价值传递路径。此外，还需关注新兴技术如何重塑传统产业链布局。",
    //   },
    //   {
    //     id: 3,
    //     label: "市场规模与增长",
    //     content:
    //       "基于历史数据和预测模型，提供全球及主要国家/地区的金融业市场规模现状和发展趋势分析；重点考察近年来驱动行业增长的关键因素（如数字化转型、政策支持等），并结合宏观经济环境评估未来几年的增长潜力。",
    //   },
    // ]
    getOutline()
  }
})

// Methods
const handleClose = () => {
  isVisible.value = false
  emit("close") // 触发关闭事件，可以在父组件监听此事件来处理关闭后的逻辑。
}
const request = reactive({
  data: {},
})
const replaceKeyInTree = (tree, oldKey, newKey) => {
  return tree.map((node) => ({
    ...node,
    [newKey]: node[oldKey], // 将oldKey的值赋给newKey
    children: node.children
      ? replaceKeyInTree(node.children, oldKey, newKey)
      : undefined, // 递归处理子节点
  }))
}
const updateKeyInTree = (tree, key) => {
  // 检查当前节点是否包含该 key，如果不包含，则添加它
  if (tree instanceof Array) {
    tree.forEach((node) => {
      // 如果已存在，直接更新其值为 true（这里根据你的需求，你也可以设置其他值）
      // node[key] = node[key].;
      if (!node[key].trim()) {
        isNull.value = true
      }
      // 如果节点有 children，则递归处理每个子节点
      if (node.children) {
        node.children.forEach((child) => {
          updateKeyInTree(child, key)
        })
      }
    })
  } else {
    console.log(tree, "1111ss")
    let node = tree
    console.log(node[key], node, "node[key]")
    if (!node[key].trim()) {
      isNull.value = true
    }
    // 如果节点有 children，则递归处理每个子节点
    if (node.children) {
      node.children.forEach((child) => {
        updateKeyInTree(child, key)
      })
    }
  }
}

// 使用函数更新树结构中的 key 值

const handleConfirm = () => {
  isNull.value = false
  updateKeyInTree(list[currentId.value].data, "label")
  if (isNull.value) {
    return
  }
  if (currentId.value == -1) {
    ElMessage.warning("请选择目录")
    return
  }
  let data=replaceKeyInTree(list[currentId.value].data, "label", "title")
  request.data = {
    section: props.profession ? JSON.parse(props.profession).industryName : "",
    content: "请分析相关内容",
    outline:data,
  }
  emit("confirm",  request.data)
  // WebSocketCatalogue(request.data)
  // 触发确认事件，可以在父组件监听此事件来处理确认后的逻辑。
}
</script>
<style lang="less" scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.dialog-content {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .mulu-item {
    display: flex;
    margin-bottom: 10px;
    width: 48%;

    height: 100%;
    min-height: 400px;
    box-sizing: content-box;
    border: 1px solid #fff;
    .left {
      width: 100%;
      background: #efc585;
      padding: 20px 15px;
      color: #fff;
      // h5{
      //     color:#fff
      // }
    }
    .right {
      padding: 20px 15px;
      width: 100%;
      background: #f9f9f9;
    }
  }
  .mulu-item:hover {
    border: 1px solid #4fa1c4;
  }
  h5 {
    margin-bottom: 10px;
  }
}
::v-deep .el-tree-node__content {
  height: 30px;
}
::v-deep .el-tree {
  height: 300px;
  overflow: auto;
}
.content-error {
  ::v-deep .el-input__inner {
    border: 1px solid red;
  }
}
.error {
  color: red;
  font-size: 12px;
  scale: 0.9;
}
</style>
